import { PaletteMode, useTheme } from "@mui/material";
import { colors } from "../theme/colors";

const getVerticalGradient = (mode: PaletteMode) => {
  const colorFrom = mode === "light" ? colors.gradientFromLight : colors.gradientFromDark;
  const colorTo = mode === "light" ? colors.gradientToLight : colors.gradientToDark;

  return `linear-gradient(180deg, ${colorFrom} 0%, ${colorTo} 100%)`;
};

const getHorizontalGradient = (mode: PaletteMode) => {
  const colorFrom = mode === "light" ? colors.brown : colors.purple;
  const colorTo = mode === "light" ? colors.lightBrown : colors.lightPurple;

  return `linear-gradient(84deg, ${colorFrom} 0%, ${colorTo} 100%)`;
};

export const useGradient = (variant: "horizontal" | "vertical", forceMode?: PaletteMode) => {
  const theme = useTheme();

  switch (variant) {
    case "horizontal":
      return getHorizontalGradient(forceMode ?? theme.palette.mode);
    case "vertical":
      return getVerticalGradient(forceMode ?? theme.palette.mode);
  }
};
